import { useEffect, useState } from 'react';
import { agentSessionsService } from '@/services/roros/agent-sessions.service';

export function useAgentSessionArtifacts(activeSessionId?: string, isStreaming?: boolean) {
  const [showArtifacts, setShowArtifacts] = useState(false);
  const [artifactsCount, setArtifactsCount] = useState(0);

  // AC-M5-3: refresh artifact count whenever session changes or a message completes
  useEffect(() => {
    if (!activeSessionId) { setArtifactsCount(0); return; }
    agentSessionsService.getArtifacts(activeSessionId)
      .then((arts) => setArtifactsCount(arts.length))
      .catch(() => setArtifactsCount(0));
  }, [activeSessionId, isStreaming]);  // refresh after each streaming turn ends

  return {
    showArtifacts,
    setShowArtifacts,
    artifactsCount,
  };
}
